import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { wishTiming } from './Helper';
import { originalValues } from './Helper';
import Str from './Str';
import PageHeader from './GlobalElements/PageHeader';

export default function HomeWishes(props) {
    const brandConfig = useSelector((state) => state.brand);
    const user = JSON.parse(localStorage.getItem('user'));
    const componentMounted = React.useRef(true);
    const intervalRef = useRef(null);
    const [time, setTime] = useState(
        moment(Date().toLocaleString()).format(`dddd, ${Str.TABLE_DATE_FORMAT} | ${Str.TABLE_TIME_FORMAT}:ss`),
    );

    useEffect(() => {
        componentMounted.current = true;
        intervalRef.current = setInterval(() => {
            if (componentMounted.current) {
                // is component still mounted?
                setTime(
                    moment(Date().toLocaleString()).format(
                        `dddd, ${Str.TABLE_DATE_FORMAT} | ${Str.TABLE_TIME_FORMAT}:ss`,
                    ),
                );
            }
        }, 1000);
        return () => {
            componentMounted.current = false;
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);
    return (
        <>
            {!props.hide ? (
                <PageHeader
                    title={
                        <>
                            {wishTiming(new Date())} <span>{user != null && originalValues(user.fullname)}</span>
                        </>
                    }
                    right={<p className=""> {time}</p>}
                />
            ) : (
                <span className="ml-auto">{time}</span>
            )}
        </>
    );
}
